import pluralize from "pluralize";
import {Link} from "react-router";

import {CheckTypeDisplay, MonitoringServiceType} from "@/lib/types/checks.ts";
import {InstantPopUp} from "@/pages/billing/v1/instantCheckout/InstantPopUp.tsx";

interface PopupContactSupportProps {
  show: boolean;
  onComplete: () => void;
  service: MonitoringServiceType;
  amount: number;
}

export const PopupContactSupport = ({show, onComplete, service, amount}: PopupContactSupportProps) => {
  const subject = `A request for extra ${amount} ${CheckTypeDisplay[service]} ${pluralize("Check", amount)}`;
  const message = `Hello,\n\nI would like to request an upgrade to my plan to add ${amount} additional ${CheckTypeDisplay[service]} Checks. The current plan does not support this feature.\n\nThank you!`;
  return (
    <InstantPopUp
      show={show}
      onConfirm={async () => {
        onComplete();
      }}
      title={`Please contact us to add ${CheckTypeDisplay[service]} Checks`}
      alertCallout={`${CheckTypeDisplay[service]} Checks are not available on your current plan`}
      alertChildren={
        <span>
          If you would like to upgrade your subscription to add {CheckTypeDisplay[service]} Checks, please&nbsp;
          <Link to={`/contact?subject=${encodeURI(subject)}&message=${encodeURI(message)}`} target="_blank">
            contact us
          </Link>
        </span>
      }
      onCancel={onComplete}
      btnTitle="Ok"
    />
  );
};
